import { render, staticRenderFns } from "./ChangePersonDialog.vue?vue&type=template&id=587bbdd9&scoped=true"
import script from "./ChangePersonDialog.vue?vue&type=script&lang=js"
export * from "./ChangePersonDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangePersonDialog.vue?vue&type=style&index=0&id=587bbdd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587bbdd9",
  null
  
)

export default component.exports